import { ADD_INFO_EKYC, REMOVE_INFO_EKYC } from '../constants';

const initialState = {
  data: null
};

export function ekycReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_INFO_EKYC:
      return {
        ...state,
        data: action.payload
      };
    case REMOVE_INFO_EKYC:
      return {
        data: null
      };

    default:
      return state;
  }
};
